import React from 'react';

import { PaymentMethodsWizard } from '@swf/first';

import FirstRoute from './FirstRoute';

const PaymentMethodsRoute: React.FC = () => <FirstRoute component={PaymentMethodsWizard} noCache />;

export default PaymentMethodsRoute;
